export default __webpack_public_path__ + "static/media/register4.85c17d78.jpg";